import React, { Component } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { handleFormStep } from "../../../store/actions/application";
import Store from "../../../store";
import { useRouter } from "next/router";
import { openChatBox } from "../../../store/actions/messages";
import { representative } from "../../../constants";

function BayanProgress(props) {
  const router = useRouter();

  const { userAuth } = Store.getState();
  const dispatch = useDispatch();
  const { savedSteps, bayanProgress } = useSelector(
    (state) => ({
      savedSteps: state.applicationReducer.savedSteps,
      bayanProgress: state.applicationReducer.bayanProgress,
    }),
    shallowEqual
  );
  const handleChat = () => {
    if (userAuth && userAuth.userId) {
      dispatch(openChatBox(representative));
    } else {
      router.push("/register");
    }
  };

  const handleStepClick = (step) => {
    if (props.isReviewOpen) {
      props.closeReview();
    }
    dispatch(handleFormStep(step));
  };

  const isLoggedOutUserInfo =
    !!savedSteps.loggedOutUserInfo &&
    !!Object.keys(savedSteps.loggedOutUserInfo).length;
  const isApplicantInfo =
    !!savedSteps.applicantInfo &&
    !!Object.keys(savedSteps.applicantInfo).length;
  const isContactInfo =
    !!savedSteps.contactInfo && !!Object.keys(savedSteps.contactInfo).length;
  const isResidency =
    !!savedSteps.residency && !!Object.keys(savedSteps.residency).length;
  const isDemographics =
    !!savedSteps.demographics && !!Object.keys(savedSteps.demographics).length;
  const isAcademicInfo =
    !!savedSteps.academicInfo && !!Object.keys(savedSteps.academicInfo).length;
  const isEducationalHistory =
    !!savedSteps.educationalHistory &&
    !!Object.keys(savedSteps.educationalHistory).length;
  const isToeflScore =
    !!savedSteps.toeflScore && !!Object.keys(savedSteps.toeflScore).length;
  const isApplicationEssay =
    !!savedSteps.applicationEssay &&
    !!Object.keys(savedSteps.applicationEssay).length;
  const isTranscripts =
    !!savedSteps.transcripts && !!Object.keys(savedSteps.transcripts).length;
  const isReferences =
    !!savedSteps.references && !!Object.keys(savedSteps.references).length;
  const isApplicationFee =
    !!savedSteps.applicationFee &&
    !!Object.keys(savedSteps.applicationFee).length;
  return (
    <div>
      <div className="card bayan-progress-wrapper">
        <ul className="progress-list">
          <ProgressHeader percentage={bayanProgress} />
          <li className="app-sections-label">Complete Sections</li>

          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isLoggedOutUserInfo ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${
                isLoggedOutUserInfo ? "" : "disable-mouse"
              }`}
              onClick={() => {
                handleStepClick("loggedOutUserInfo");
              }}
            >
              Program Selection
            </div>
          </li>

          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isApplicantInfo ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${isApplicantInfo ? "" : "disable-mouse"}`}
              onClick={() => {
                handleStepClick("applicantInfo");
              }}
            >
              Applicant Information
            </div>
          </li>
          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isContactInfo ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${isContactInfo ? "" : "disable-mouse"}`}
              onClick={() => {
                handleStepClick("contactInfo");
              }}
            >
              Contact Information
            </div>
          </li>
          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isResidency ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${isResidency ? "" : "disable-mouse"}`}
              onClick={() => {
                handleStepClick("residency");
              }}
            >
              Residency
            </div>
          </li>
          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isDemographics ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${isDemographics ? "" : "disable-mouse"}`}
              onClick={() => {
                handleStepClick("demographics");
              }}
            >
              Demographics
            </div>
          </li>
          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isAcademicInfo ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${isAcademicInfo ? "" : "disable-mouse"}`}
              onClick={() => {
                handleStepClick("academicInfo");
              }}
            >
              Academic Information
            </div>
          </li>
          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isEducationalHistory ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${
                isEducationalHistory ? "" : "disable-mouse"
              }`}
              onClick={() => {
                handleStepClick("educationalHistory");
              }}
            >
              Educational History
            </div>
          </li>
          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isToeflScore ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${isToeflScore ? "" : "disable-mouse"}`}
              onClick={() => {
                handleStepClick("toeflScore");
              }}
            >
              TOEFL Score
            </div>
          </li>
          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isTranscripts ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${isTranscripts ? "" : "disable-mouse"}`}
              onClick={() => {
                handleStepClick("transcripts");
              }}
            >
              Transcripts
            </div>
          </li>
          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isReferences ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${isReferences ? "" : "disable-mouse"}`}
              onClick={() => {
                handleStepClick("references");
              }}
            >
              References
            </div>
          </li>
          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isApplicationEssay ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${
                isApplicationEssay ? "" : "disable-mouse"
              }`}
              onClick={() => {
                handleStepClick("applicationEssay");
              }}
            >
              Essay
            </div>
          </li>
          <li className="progress-list-items">
            <div className="check-mark-wrapper">
              <i
                className={`fa fa-check check-mark ${
                  isApplicationFee ? "selected-check-mark" : ""
                }`}
              ></i>
            </div>
            <div
              className={`list-label ${
                isApplicationFee ? "" : "disable-mouse"
              }`}
              onClick={() => {
                handleStepClick("applicationFee");
              }}
            >
              Application Fee
            </div>
          </li>
        </ul>

        {savedSteps.applicantInfo && (
          <button className="review-application-btn" onClick={props.openReview}>
            Review Application
          </button>
        )}
      </div>
      {/* <div className="card connect-cart cursor-pointer" onClick={() => handleChat()}>
          <span className="chat-img">
            <img src="https://bayan.s3-us-west-2.amazonaws.com/static-content/profile-img.png.webp" width="56" />
            <img className="company-icon" src="https://bayan.s3-us-west-2.amazonaws.com/static-content/LoginLogo.png.webp" width="26"/>
          </span>
          <p>Connect with a Counselor</p>
          <span className="chat"></span>
        </div> */}
    </div>
  );
}

function ProgressHeader({ percentage }) {
  return (
    <li className="progress-header">
      <div className="progress-percentage">
        <CircularProgressbar
          maxValue={100}
          value={percentage || 0}
          text={`${!!percentage ? (percentage > 100 ? 100 : percentage) : 0}%`}
        />
      </div>
      <div className="progress-text">
        <div className="title">Graduate School Application</div>
      </div>
    </li>
  );
}

export default BayanProgress;
